import { dimensions, SvgIconProps } from "./SvgIcon";

export const PivotTableIcon = (
  props: SvgIconProps & { inactive?: boolean }
) => {
  const { width, height } = dimensions(props);
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* L-shaped table */}
      <path
        d="M5 4C5 3.44772 5.44772 3 6 3H14C14.5523 3 15 3.44772 15 4V6H5V4Z"
        fill="currentColor"
      />
      <path
        d="M4 7C3.44772 7 3 7.44772 3 8V16C3 16.5523 3.44772 17 4 17H6V7H4Z"
        fill="currentColor"
      />
      {/* Arrow */}
      <path
        d="M8 15L15 15L15 8L12 11M15 8L18 11"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
